import Rating from "react-rating";
import { FaRegStar, FaStar } from "react-icons/fa";
import { forwardRef, useEffect, useState } from "react";
import ReactDatePicker from "react-datepicker";
import { LuCalendarDays } from "react-icons/lu";

import MultiSelect from "react-select";
// import { components } from "react-select";
import "react-datepicker/dist/react-datepicker.css";

import React, { useImperativeHandle, useRef } from "react";
import { type } from "@testing-library/user-event/dist/type";

export const RatingStar = ({
  user = null,
  rating,
  readonly = false,
  onChange,
  ...rest
}) => {
  const handleChange = (value) => {
    const newValue = value; // Convert back to the desired increment value
    if (onChange) {
      onChange(newValue); // Update the rating
    }
  };

  return (
    <>
      <div className="rating">
        {/* <span className="_rating">{rating}</span> */}
        <Rating
          stop={rating}
          readonly={readonly}
          className="rating_star"
          emptySymbol={<FaRegStar />}
          fullSymbol={<FaStar />}
          fractions={1}
          onChange={readonly ? undefined : handleChange} // Update value only if not readonly
          {...rest}
        />
        {user && <span className="user">{user}</span>}
      </div>
    </>
  );
};

export const Input = forwardRef(
  (
    {
      value,
      onChange,
      className = "",
      label,
      error,
      required,
      extraError = false,
      infoErr = false,
      ...rest
    },
    ref
  ) => {
    const classGenerator = () => {
      if (infoErr && extraError) {
        return "is-invalid";
      }
      if (infoErr) {
        return "info";
      }
      return ((!value && error) || extraError) && "is-invalid";
    };

    return (
      <>
        {label && (
          <label className="label">
            {label}
            {required && <span className="required mx-1"> *</span>}
          </label>
        )}
        <input
          value={value}
          onChange={onChange}
          className={`form-control input ${className} ${classGenerator()}`}
          {...rest}
          ref={ref}
        />
        {error && (
          <p className={`${infoErr ? "info-feedback" : "invalid-feedback text-danger"}`}>
            {error}
          </p>
        )}
      </>
    );
  }
);

export const Select = forwardRef(
  (
    {
      label,
      onChange,
      value,
      error,
      className = "",
      children,
      required,
      ...rest
    },
    ref
  ) => {
    return (
      <>
        {label && (
          <label className="label">
            {label}
            {required && <span className="required mx-1"> *</span>}
          </label>
        )}
        <select
          onChange={onChange}
          value={value}
          className={`form-control input${className} ${
            !value && error && "is-invalid"
          }`}
          {...rest}
          ref={ref}
        >
          {children}
        </select>
        {error && <div className="invalid-feedback">{error}</div>}
      </>
    );
  }
);

export const TextArea = forwardRef(
  ({ value, onChange, label, className = "", error, ...rest }, ref) => {
    return (
      <>
        {label && <label className="label my-1">{label}</label>}
        <textarea
          value={value}
          onChange={onChange}
          className={`form-control input${className} ${
            !value && error && "is-invalid"
          }`}
          ref={ref}
          {...rest}
        />
        {error && <div className="invalid-feedback">{error}</div>}
      </>
    );
  }
);

// export const DatePicker = forwardRef(
//   (
//     {
//       value,
//       onChange,
//       className = "",
//       label,
//       error,
//       required,
//       extraError = false,
//       infoErr = false,
//       optional = false,
//       ...rest
//     },
//     ref
//   ) => {
//     const classGenerator = () => {
//       if (infoErr && extraError) {
//         return "is-invalid";
//       }
//       if (infoErr) {
//         return "info";
//       }
//       return ((!value && error) || extraError) && "is-invalid";
//     };
//     return (
//       <>
//         {label && (
//           <label className="label">
//             {label}
//             {required && <span className="required mx-1"> *</span>}
//             {optional && <em className="optional">{"(optional)"}</em>}
//           </label>
//         )}
//         <ReactDatePicker
//           ref={ref}
//           className={`form-control input ${className} ${classGenerator()}`}
//           showIcon
//           icon={<LuCalendarDays />}
//           selected={value}
//           onChange={onChange}
//           dateFormat="dd-MMM-yyyy"
//           showMonthDropdown
//           useShortMonthInDropdown
//           showYearDropdown
//           scrollableYearDropdown
//           onChangeRaw={(e) => e.preventDefault()}
//           {...rest}
//           yearDropdownItemNumber={300}
//         />
//         {!value && error && (
//           <span
//             className={`${
//               infoErr ? "info-feedback" : "invalid-feedback"
//             } d-block`}
//           >
//             {error}
//           </span>
//         )}
//       </>
//     );
//   }
// );

export const Button = ({ className = "", loading, children, ...rest }) => {
  return (
    <>
      <button
        className={`button ${className} ${loading ? "loading" : ""}`}
        {...rest}
      >
        {loading ? <span className="button_loader"></span> : children}
      </button>
    </>
  );
};

export const LoadingButton = ({
  children,
  loading,
  className = "",
  ...rest
}) => {
  return (
    <button
      className={`button has_loader ${className}`}
      {...rest}
    >
      {loading ? (
        <>
          <svg
            version="1.1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            width="24px"
            height="30px"
            viewBox="0 0 24 30"
            // style="enable-background:new 0 0 50 50;"
            className="loading_icon"
          >
            <rect x="0" y="13" width="4" height="5" fill="#fff">
              <animate
                attributeName="height"
                attributeType="XML"
                values="5;21;5"
                begin="0s"
                dur="0.6s"
                repeatCount="indefinite"
              />
              <animate
                attributeName="y"
                attributeType="XML"
                values="13; 5; 13"
                begin="0s"
                dur="0.6s"
                repeatCount="indefinite"
              />
            </rect>
            <rect x="10" y="13" width="4" height="5" fill="#fff">
              <animate
                attributeName="height"
                attributeType="XML"
                values="5;21;5"
                begin="0.15s"
                dur="0.6s"
                repeatCount="indefinite"
              />
              <animate
                attributeName="y"
                attributeType="XML"
                values="13; 5; 13"
                begin="0.15s"
                dur="0.6s"
                repeatCount="indefinite"
              />
            </rect>
            <rect x="20" y="13" width="4" height="5" fill="#fff">
              <animate
                attributeName="height"
                attributeType="XML"
                values="5;21;5"
                begin="0.3s"
                dur="0.6s"
                repeatCount="indefinite"
              />
              <animate
                attributeName="y"
                attributeType="XML"
                values="13; 5; 13"
                begin="0.3s"
                dur="0.6s"
                repeatCount="indefinite"
              />
            </rect>
          </svg>
        </>
      ) : (
        children
      )}
    </button>
  );
};

export const CommonSelect = ({
  label,
  onChange,
  value,
  error,
  className = "",
  options = [],
  isMulti = false,
  isSearchable = false,
  noOptionsMessage = () => "No options found",
  required = false,
  loading = false,
  isDisabled = false,
  placeholder = "Select",
  ...rest
}) => {
  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      background: state.isSelected ? "#808080" : "#fff", // Change background color of selected option
      color: state.isSelected ? "#fff" : "#000", // Change text color of selected option
      "&:hover": {
        background: "#808080", // Change background color of option on hover
        color: "#fff", // Change text color of option on hover
      },
    }),
    loadingIndicator: (base, state) => ({
      ...base,
      color: "#FF8989", // Set the color to red
    }),
  };

  // const CustomDropdownIndicator = (props) => {
  //   const { menuIsOpen } = props.selectProps; // Access menu open state
  //   return (
  //     <components.DropdownIndicator {...props}>
  //       {menuIsOpen ? <FaChevronUp /> : <FaChevronDown />}
  //     </components.DropdownIndicator>
  //   );
  // };

  // const LoadingIndicator = (props) => {
  //   return (
  //     <components.LoadingIndicator {...props}>
  //       {/* <ClipLoader size={20} color="#999" loading={true} />
  //        */}
  //       <p>Loading...</p>
  //     </components.LoadingIndicator>
  //   );
  // };

  const handleChange = (selectedOptions) => {
    onChange(selectedOptions);
  };

  // const handleMenuToggle = (state) => {
  //   setMenuOpen(state);
  // };

  // console.log(menuOpen, "menuOpen");

  return (
    <div>
      {label && <label className="label">{label}</label>}
      {required && <span className="text-danger"> *</span>}

      <MultiSelect
        onChange={handleChange}
        value={value}
        className={`form-control multi-select ${className} ${
          !value && error && "is-invalid"
        }`}
        classNamePrefix="select"
        options={options}
        isMulti={isMulti}
        placeholder={placeholder}
        isSearchable={isSearchable}
        noOptionsMessage={noOptionsMessage}
        isLoading={loading}
        styles={customStyles}
        isDisabled={isDisabled}
        // onMenuOpen={() => setMenuIsOpen(true)}
        // onMenuClose={() => setMenuIsOpen(false)}
        // menuIsOpen={menuIsOpen}
        {...rest}
      />
      {/* {leftIcon} */}

      {error && <div className="invalid-feedback d-flex">{error}</div>}
    </div>
  );
};

// Switch Button //
export const SwitchButton = ({
  className = "",
  status = false,
  disabled,
  ...rest
}) => {
  return (
    <>
      <label
        className={`switch_button ${className} ${disabled ? "disabled" : ""}`}
      >
        <input type="checkbox" checked={status} disabled={disabled} {...rest} />
        <span className="slider round"></span>
      </label>
    </>
  );
};


export const DatePicker = forwardRef(
  (
    {
      value,
      onChange,
      className = "",
      label,
      error,
      required,
      extraError = false,
      infoErr = false,
      optional = false,
      placeholder,
      ...rest
    },
    ref
  ) => {
    const classGenerator = () => {
      if (infoErr && extraError) {
        return "is-invalid";
      }
      if (infoErr) {
        return "info";
      }
      return ((!value && error) || extraError) && "is-invalid";
    };
    return (
      <>
        {label && (
          <label className="label">
            {label}
            {required && <span className="required mx-1"> *</span>}
            {optional && <em className="optional">{"(optional)"}</em>}
          </label>
        )}
        <ReactDatePicker
          ref={ref}
          className={`form-control input ${className} ${classGenerator()}`}
          showIcon
          icon={<LuCalendarDays />}
          selected={value}
          onChange={onChange}
          dateFormat="dd-MMM-yyyy"
          showMonthDropdown
          useShortMonthInDropdown
          showYearDropdown
          scrollableYearDropdown
          onChangeRaw={(e) => e.preventDefault()}
          {...rest}
          yearDropdownItemNumber={300}
          placeholderText={placeholder}
        />
        {!value && error && (
          <span
            className={`${
              infoErr ? "info-feedback" : "invalid-feedback"
            } d-block`}
          >
            {error}
          </span>
        )}
      </>
    );
  }
);